import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const convertDateToISO = (value: string) => {
  if (dayjs(value).isValid()) {
    // Native получение таймзоны Intl.DateTimeFormat().resolvedOptions().timeZone
    return dayjs(value).tz(dayjs.tz.guess());
  }
  return value;
};

export const convertToDatePickerInput = (iso: string) => {
  if (dayjs(iso).isValid()) {
    return dayjs(iso).format().slice(0, -6);
  }
  return iso;
};